import { Project } from './project';
import { User } from './user';

export enum ExpenseType {
  VENDOR_PAYMENT = 'VENDOR_PAYMENT',
  PURCHASE = 'PURCHASE',
  TRANSPORT = 'TRANSPORT',
  FOOD = 'FOOD',
  ADMIN = 'ADMIN',
  MARKETING = 'MARKETING',
  OFFICE = 'OFFICE',
  DAILY_LABOR_BILL = 'DAILY_LABOR_BILL',
  CONSUMABLE = 'CONSUMABLE',
}

export enum ExpenseStatus {
  PAID = 'PAID',
  PAYABLE = 'PAYABLE',
}

export interface Expense {
  id: number;
  amount: string;
  date: string;
  expense_type: ExpenseType;
  description: string;
  project: number;
  project_details?: Project;
  submitted_by: number;
  submitted_by_details?: User;
  status: ExpenseStatus;
  remark: string;
  created_at: string;
  updated_at: string;
}

export interface NewExpense {
  project: number | null;
  amount: number;
  date: string; // YYYY-MM-DD
  expense_type: ExpenseType;
  description?: string;
  status: ExpenseStatus;
  remark?: string;
}

export interface PaymentReceived {
  id: number;
  amount: string;
  date_received: string;
  description: string;
  project: number;
  project_details?: Project;
  received_by: number;
  received_by_details?: User;
  created_at: string;
  updated_at: string;
}

export interface NewPaymentReceived {
  project: number;
  amount: number;
  date_received: string; // YYYY-MM-DD
  description: string;
  received_by: number | null;
}

export interface EmployeePettyCashSummary {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  role: string;
  total_received: number;
  total_spent: number;
  balance: number;
}

export interface AdvancePettyCash {
  id: number;
  date: string;
  amount: string;
  notes: string;
  paid_by: number;
  paid_by_details?: User;
  paid_to: number;
  paid_to_details?: User;
  created_at: string;
  updated_at: string;
}

export interface NewAdvancePettyCash {
  paid_to: number;
  amount: number;
  date: string; // YYYY-MM-DD
  notes?: string;
}